export default __webpack_public_path__ + "locales/ar-SA/ChangeUserTypeDialog.json?hash=8eac747b762276414de389ba623d1d2f";